<template>


        <button  class="button--primary" @click="saveLanguage">
                {{ $t('navigation.desired_language')}}
        </button>


     
</template>

<script>
export default {
  name: "SelectLang",
  data() {
    return { 
        langs: ["es", "en"],
        lang: "es"
    };
  },
  methods: {
    saveLanguage() {
        const lang = (this.$i18n.locale === 'en') ? 'es' : 'en'; 
        sessionStorage.setItem("lang", lang);
        const selectedLang = sessionStorage.getItem("lang");
        this.$i18n.locale = selectedLang;
        this.$root.$emit('languageChanged')
    }
  }
};
</script>